<template>
  <collapsible-widget title="GEOMETRIA OBIEKTU" :accordion="accordion" :default-expanded="true">
    <b-form class="p-2">
      <b-form-group label="Długość geograficzna" label-for="newPointX" label-size="sm">
        <b-row v-show="xCoordinateInvalid">
          <b-col>
            <small class="text-danger">Wartość niepoprawna.</small>
          </b-col>
        </b-row>
        <b-form-input id="newPointX" size="sm" v-model.number="newPoint.x" placeholder="Wpisz długość geograficzną" type="number" :state="xCoordinateInvalid ? false : null"></b-form-input>
      </b-form-group>
      <b-form-group label="Szerokość geograficzna" label-for="newPointY" label-size="sm">
        <b-row v-show="yCoordinateInvalid">
          <b-col>
            <small class="text-danger">Wartość niepoprawna.</small>
          </b-col>
        </b-row>
        <b-form-input id="newPointY" size="sm" v-model.number="newPoint.y" placeholder="Wpisz szerokość geograficzną" type="number" :state="yCoordinateInvalid ? false : null"></b-form-input>
      </b-form-group>
      <b-form-row>
        <b-col>
          <b-button class="btn-block" size="sm" variant="primary" @click="appendPoint" title="Dodaj">Dodaj</b-button>
        </b-col>
        <b-col>
          <b-button class="btn-block" size="sm" variant="outline-secondary" @click="endDrawing" title="Zakończ rysowanie">Zakończ rysowanie</b-button>
        </b-col>
      </b-form-row>
    </b-form>
    <div id="geometry-table" class="p-2">
      <table class="table table-sm">
        <thead>
          <tr>
            <th><small>lp.</small></th>
            <th><small>Długość geograficzna</small></th>
            <th><small>Szerokość geograficzna</small></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(coordinate, index) in coordinates" :key="index">
            <td>{{ index + 1 }}</td>
            <td><b-input size="sm" v-model.number="coordinate[0]" type="number" @change="changedGeometry(index)"></b-input></td>
            <td><b-input size="sm" v-model.number="coordinate[1]" type="number" @change="changedGeometry(index)"></b-input></td>
            <td>
              <a href="#" title="Usuń" @click.prevent.stop="deletePoint(index)">
                <icon name="trash"></icon>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>   
  </collapsible-widget>
</template>

<script>
import { mapGetters } from 'vuex';
import { ROAD_LANE_FEATURE_END_DRAWING } from '../store/actions.type';
import { ROAD_LANE_FEATURE_ADD_POINT_MANUALLY, ROAD_LANE_POINT_CHANGED, ROAD_LANE_FEATURE_DELETE_POINT } from '../store/mutations.type';
import CollapsibleWidget from "./CollapsibleWidget";

export default {
  props: {
    accordion: {
      type: String,
      default: 'panel'
    }
  },
  name: 'RoadLaneAnalysisGeometry',
  components: {
    CollapsibleWidget
  },
  data() {
    return {
      coordinates: [],
      newPoint: { x: null, y: null },
      dirty: false
    };
  },
  computed: {
    ...mapGetters(['roadLaneFeature']),
    xCoordinateInvalid() {
      return this.dirty && (this.newPoint.x == "" || this.newPoint.x == null || this.newPoint.x == undefined);
    },
    yCoordinateInvalid() {
      return this.dirty && (this.newPoint.y == "" || this.newPoint.y == null || this.newPoint.y == undefined);
    }
  },
  mounted() {
    if (this.roadLaneFeature) {
      const self = this;
      this.roadLaneFeature.on("change", evt => { self.coordinates = evt.target.getGeometry().getCoordinates(); });
    }
  },
  watch: {
    roadLaneFeature(value) {
      if (value == null || value == undefined) {
        this.coordinates = [];
      } else {
        this.coordinates = this.roadLaneFeature.getGeometry().getCoordinates();

        const self = this;
        this.roadLaneFeature.on("change", evt => { self.coordinates = evt.target.getGeometry().getCoordinates(); });
      }
    }
  },
  methods: {
    async appendPoint() {
      this.dirty = true;
      if (this.validateNewPointCoordinates()) {
        await this.$store.commit(ROAD_LANE_FEATURE_ADD_POINT_MANUALLY, [this.newPoint.x, this.newPoint.y]);
        this.newPoint.x = this.newPoint.y = null;
        this.dirty = false;
      }
    },
    async changedGeometry(index) {
      await this.$store.commit(ROAD_LANE_POINT_CHANGED, { index: index, coordinates: this.coordinates[index] });
    },
    async deletePoint(index) {
      await this.$store.commit(ROAD_LANE_FEATURE_DELETE_POINT, index);
    },
    endDrawing() {
      this.$store.dispatch(ROAD_LANE_FEATURE_END_DRAWING);
    },
    validateNewPointCoordinates() {
      return !this.xCoordinateInvalid && !this.yCoordinateInvalid;
    }
  }
}
</script>
